/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Mic_LevelInputs */



/**
* | output |
* | --- |
* | "Microphone level" |
*
* @param {Practice_Session_Mic_LevelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_mic_level = /** @type {((inputs?: Practice_Session_Mic_LevelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Mic_LevelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Microfoonniveau")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Niveau du micro")
	return /** @type {LocalizedString} */ ("Microphone level")
});